module.exports = __webpack_public_path__ + "static/media/3.ddd0c560.png";